<div id="container-home-page">
  <div class="card card-home-page-white text-black">
    <div class="container">
      <div class="row mtb-50">
        <div class="col-md-12">
          <h1 class="card-title mt-50 mb-5 text-center">Privacy Policy</h1>
          <p>Effective: May 21st, 2015</p>
          <p class="card-text mt-4 left text-start">
            This PRIVACY POLICY ("Policy") governs the website and other online
            services provided by The Story of Life, LLC. ("TSOLife"). This
            Policy applies only to TSOLife’s family of online assets. It does
            not necessarily reflect TSOLife's offline privacy policies. This
            Policy is an integral part of TSOLife’s Terms of Service and is
            integrated therein. If not otherwise defined herein, the definition
            of any capitalized term is the same as the definition in the
            Terms.<br /><br />

            TSOLife collects information about you when you register and when
            you contact us, sign up for our newsletter or use the TSOLife
            websites and related services (the "Services").<br /><br />

            When you register for our newsletter or contact us, we require your
            first name, last name, email address, and phone number.<br /><br />

            When you visit a TSOLife website, we send one or more cookies - a
            small file containing a string of characters - to your computer that
            uniquely identifies your browser. We use cookies to improve the
            quality of our service by storing user preferences and tracking user
            trends.<br /><br />

            When you use one of our websites, our servers automatically record
            information that your browser sends whenever you visit a website.
            These server logs may include information such as your Internet
            Protocol address, cookie information, and the page you request.<br /><br />

            When you send email or other communications to TSOLife, TSOLife may
            retain those communications indefinitely.<br /><br />

            TSOLife may use your information for any legally permissible purpose
            in TSOLife’s sole discretion, except that TSOLife will never sell
            your information. The following describes how TSOLife currently uses
            individual information, but TSOLife may change or broaden its use at
            any time as permitted by law. TSOLife uses information for the
            following general purposes: to fulfill requests for products,
            services, or information, to improve our services, and to contact
            you when necessary. TSOLife may also disclose your information to
            respond to subpoenas, court orders, or legal process, or to
            establish or exercise our legal rights or defend against legal
            claims. TSOLife may also disclose your information if TSOLife
            believes it is necessary to share information in order to
            investigate, prevent, or take action regarding illegal activities,
            suspected fraud, situations involving potential threats to the
            physical safety of any person, violations of the Terms or any
            Agreement, or as otherwise required by law.<br /><br />

            Children under 13 are not permitted to disclose any personally
            identifying information in relation to any Service. This means that
            children may not register for any product or service.<br /><br />

            There are commercially available services and software that limit
            access to objectionable information.<br /><br />

            You can edit your account information at any time by contacting
            TSOLife at support@tsolife.com. You can delete your account at any
            time by contacting TSOLife at support@tsolife.com. Some information
            about you and your account may remain in our archived records after
            modification and/or deletion.<br /><br />

            If TSOLife becomes involved in a merger, acquisition, or any form of
            sale of some or all of its assets, we will transfer the information
            to the resulting entity, which may or may not utilize the same
            privacy policy.<br /><br />

            Third Party Applications. TSOLife may make third party applications
            available through the Website. The information collected by TSOLife
            when you use a third party application is governed by this Privacy
            Policy. Information collected by the third party application
            provider is governed by the third party's privacy policy.<br /><br />
            TSOLife may update this policy at any time. We will notify you about
            significant changes in the way we treat personal information by
            placing a prominent notice on our website.<br /><br />

            If you have any questions or comments about this policy, please
            contact us at support@tsolife.com.<br /><br />
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
